<template>
  <div class="loader-page-content" :class="{ 'is-transparent': transparent }">
    <div class="spinner">
      <div class="rect1"></div>
      <div class="rect2"></div>
      <div class="rect3"></div>
      <div class="rect4"></div>
      <div class="rect5"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'full-loading',
  // `transparent`: so o spinner, sem o bloco branco de 300px por tras.
  props: { transparent: { type: Boolean, default: false } },
}
</script>

<style lang="scss">
.loader-page-content {
  background: #FFFFFF;

  &.is-transparent {
    background: transparent;
    min-height: 0;
    margin: 0;
  }
  border-radius: 10px !important;
  margin-bottom: 30px;
  min-height: 300px;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  margin-top: 30px;

  .spinner {
    height: 64px;
    text-align: center;

    .rect2 {
      -webkit-animation-delay: -1.1s;
      animation-delay: -1.1s;
    }

    .rect3 {
      -webkit-animation-delay: -1.0s;
      animation-delay: -1.0s;
    }

    .rect4 {
      -webkit-animation-delay: -0.9s;
      animation-delay: -0.9s;
    }

    .rect5 {
      -webkit-animation-delay: -0.8s;
      animation-delay: -0.8s;
    }

    > div {
      margin-right: 4px;
      background-color: #2F23D6;
      width: 8px;
      height: 64px;
      display: inline-block;
      -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
      animation: sk-stretchdelay 1.2s infinite ease-in-out;
    }
  }
}


@-webkit-keyframes sk-stretchdelay {

  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4)
  }

  20% {
    -webkit-transform: scaleY(1.0)
  }
}

@keyframes sk-stretchdelay {

  0%,
  40%,
  100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }

  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/default/fullLoading.vue